// extracted by mini-css-extract-plugin
export default {"loginLogo":"Mlf+P","loginInitial":"NFWFk","loginBtn":"Ycj7P","loggedInIconContainer":"zxCHR","rewardsNotifier":"p2S-t","loggedInIconContainerCenter":"LVl+Y"};